import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { systemAdminGuard } from './core/guards/system-admin.guard';
import { ShellComponent } from './shared/components/shell/shell.component';

const routes: Routes = [
  // Public routes
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule),
    canActivate: [authGuard],
  },

  // Protected routes – Shell provides the sidebar layout
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard, systemAdminGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'organisations',
        loadChildren: () => import('./features/organisations/organisations.module').then(m => m.OrganisationsModule),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
      },
      {
        path: 'anmeldungen',
        loadChildren: () => import('./features/user-events/user-events.module').then(m => m.UserEventsModule),
      },
      {
        path: 'users/:id',
        loadChildren: () => import('./features/user-detail/user-detail.module').then(m => m.UserDetailModule),
      },
      {
        path: 'organisations/:id',
        loadChildren: () => import('./features/organisation-detail/organisation-detail.module').then(m => m.OrganisationDetailModule),
      },
      {
        path: 'templates',
        loadChildren: () => import('./features/templates/templates.module').then(m => m.TemplatesModule),
      },
      {
        path: 'industries',
        loadChildren: () => import('./features/industries/industries.module').then(m => m.IndustriesModule),
      },
      {
        path: 'templates/:id',
        loadChildren: () => import('./features/template-detail/template-detail.module').then(m => m.TemplateDetailModule),
      },
      {
        path: 'mail-queue',
        loadChildren: () => import('./features/mail-queue/mail-queue.module').then(m => m.MailQueueModule),
      },
      {
        path: 'photo-metadata',
        loadChildren: () => import('./features/photo-metadata/photo-metadata.module').then(m => m.PhotoMetadataModule),
      },
      {
        path: 'documentations',
        loadChildren: () => import('./features/documentations/documentations.module').then(m => m.DocumentationsModule),
      },
      {
        path: 'documentations/:id',
        loadChildren: () => import('./features/documentation-detail/documentation-detail.module').then(m => m.DocumentationDetailModule),
      },
      {
        path: 'email-templates',
        loadChildren: () => import('./features/email-templates/email-templates.module').then(m => m.EmailTemplatesModule),
      },
      {
        path: 'email-templates/:key',
        loadChildren: () => import('./features/email-template-edit/email-template-edit.module').then(m => m.EmailTemplateEditModule),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },

  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
